<template>
  <section class="bg-white lg:py-24 py-12">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-12">
        <div class="col-span-12">
          <!-- Logo and Brand Section -->
          <div class="grid grid-cols-12 gap-8">
            <div class="col-span-12 lg:col-span-3">
              <div class="flex items-center gap-3">
                <LogoMain />
                <span class="font-bold text-xl">Better Insights</span>
              </div>
            </div>

            <div class="col-span-12 lg:col-span-9">
              <div class="grid grid-cols-12 gap-8">
                <!-- Solutions Section -->
                <!-- <div class="col-span-6 md:col-span-4">
                  <h3
                    class="text-sm font-semibold text-gray-400 tracking-wider uppercase"
                  >
                    Solutions
                  </h3>
                  <ul role="list" class="mt-4 space-y-4">
                    <li>
                      <a
                        href="#anchor-analytics"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        Server Side
                      </a>
                    </li>
                    <li>
                      <a
                        href="#anchor-strategy"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        Data ingestion
                      </a>
                    </li>
                    <li>
                      <a
                        href="#anchor-tracking"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        Data monitoring
                      </a>
                    </li>
                    <li>
                      <a
                        href="#anchor-dashboard"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        Dashboards
                      </a>
                    </li>
                  </ul>
                </div> -->

                <!-- Support Section -->
                <div class="col-span-6 md:col-span-4">
                  <!-- <h3
                    class="text-sm font-semibold text-gray-400 tracking-wider uppercase"
                  >
                    Learn more
                  </h3>
                  <ul role="list" class="mt-4 space-y-4">
                    <li>
                      <a
                        href="/blog"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        Blog
                      </a>
                    </li> -->

                  <!-- <li>
                      <a
                        href="#"
                        class="text-base text-gray-500 hover:text-gray-900"
                      >
                        FAQ
                      </a>
                    </li> -->
                  <!-- </ul> -->
                </div>

                <!-- Company Section -->
                <div class="col-span-6 md:col-span-4">
                  <!-- <h3
                      class="text-sm font-semibold text-gray-400 tracking-wider uppercase"
                    >
                      Company
                    </h3> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Copyright Section -->
          <div class="mt-12 border-t border-gray-200 pt-8">
            <div class="flex flex-col md:flex-row justify-between items-center">
              <p class="text-base text-gray-400">
                &copy; {{ currentYear }} Better Insights, a TCR Labs company,
                all rights reserved.
              </p>
              <div class="mt-4 md:mt-0">
                <router-link
                  to="/terms"
                  class="text-base text-gray-500 hover:text-gray-900 transition-colors"
                >
                  Terms & Conditions
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import LogoMain from "@/components/shared/LogoMain.vue";
import { ref } from "vue";

const currentYear = ref(new Date().getFullYear());
</script>
